import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormWrapper from '../../../../../library/form/components/FormWrapper';

export const ProdIOListUnitCell = ({ formObject, rowKey, param1, param2, className = '' }) => {
    return (
        <li className={`uiColumnLeft uiColumn50 ${className}`.trim()}>
            <div>
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: param1 }} />
            </div>
            <FormWrapper customWrapper="div" formObject={formObject} rowKey={rowKey} action={{ paramName: param2 }} >
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: param2 }} />
            </FormWrapper>
        </li>
    );
};

export const ProdIOListQtyCell = ({ formObject, rowKey, param1, param2, className = '', format = 'a' }) => {
    return (
        <li className={`uiColumnRight uiColumnQty ${className}`.trim()}>
            <div>
                <FormROValue format={format} formObject={formObject} rowKey={rowKey} action={{ paramName: param1 }} />
            </div>
            <FormWrapper customWrapper="div" formObject={formObject} rowKey={rowKey} action={{ paramName: param2 }} >
                <FormROValue format={format} formObject={formObject} rowKey={rowKey} action={{ paramName: param2 }} />
            </FormWrapper>
        </li>
    );
};

export default ProdIOListQtyCell
